export default __webpack_public_path__ + "static/media/referral.3f39c61e.png";